export default "__VITE_ASSET__DJIDusv3__"